/**
 * 新增趋势 — GET /api/admin/stats/trends/registrations
 */
import { Table } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';

export function TrendRegistrationsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'stats', 'trends', 'registrations'],
    queryFn: () =>
      api.get<{ rows: { day: string; count: number }[] }>(
        '/api/admin/stats/trends/registrations?days=30',
      ),
  });

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>新增趋势</h2>
      <p style={{ color: '#666' }}>近 30 日按 UTC 日切分的注册用户数。</p>
      <Table
        loading={isLoading}
        size="small"
        rowKey="day"
        pagination={false}
        dataSource={data?.rows ?? []}
        columns={[
          { title: '日期 (UTC)', dataIndex: 'day', width: 140 },
          { title: '新注册', dataIndex: 'count' },
        ]}
      />
    </div>
  );
}
